import { Component,ViewChild, OnInit,Output, Input,HostListener,EventEmitter,ElementRef } from '@angular/core';
import { ListService } from '../../../services/list.service';
import { Repository } from '../../../services/repository'
import { NgSelectComponent } from '@ng-select/ng-select';
import { SatHachs_DanhSachThi } from '../../../routes/menu'
import 'jquery'
import 'bootstrap'

//import { Lists_cmmt } from '../../../routes/menu'


const swal = require('sweetalert');
@Component({
    selector: 'app-dm-danhsachthiedit',
  templateUrl: './danhsachthiedit.component.html',
    //templateUrl: 'ClientApp/routes/DanhMuc/data/data.component.html',
  styleUrls: ['./danhsachthiedit.component.scss'],
    providers: [ListService, Repository]
})


export class danhsachthieditComponent implements OnInit {

  public ngaycap: Date = null;
  public ngayhethan: Date = null;
  public ngaysinh: Date = null;
    
  quyen_them: boolean = false;
  quyen_sua: boolean = false;
  quyen_xoa: boolean = false;
  inputparents: any;
  inputnhomctmts: any;
  indLoading: boolean = false;
  doituongSelect: any = {
    Id: null, SoBaoDanh: null, HoVaTen: null, NgaySinh: null, SoCMND: null, NgayCap: null, NoiCap: null
    , TenDonVi: null, Email: null, NgayHetHan: null
    , PhanHeId: null, Created: null, Modified: null, CreatedBy: null, ModifiedBy: null
  };    
    nhomdtid:string=null;
    hoatdong:string=null;

  @ViewChild('slCapTren', { static: false }) slCapTren: NgSelectComponent;
  @ViewChild('slNhomCTMT', { static: false }) slNhomCTMT: NgSelectComponent;
    @Output() save: EventEmitter<any> = new EventEmitter();
  
  public ngxCurrencyOptions = {
    prefix: '',
    thousands: ',',
    decimal: '.',
    precision: 0,
    allowNegative: false
  };

    constructor( private _dataService: ListService, public repo: Repository) {
       
        
    }
  public ngonngu(text: string) {
    return this.repo.NgonNgu(text);
  }
    ngOnInit(): void {
       
    }

    // @HostListener('document:keydown', ['$event'])
    // public handleKeyboardEvent(event: KeyboardEvent): void {
      
    //   if(event.key==="F9")
    //   {
    //       this.saveproduct();
    //   }
    //   event.stopPropagation();
     
    // }

    comboSearchFn(term: string, item: any) {
        term = term.toLowerCase();
        return item.Ma_Doi_Tuong.toLowerCase().indexOf(term) > -1 || item.Ten_Doi_Tuong.toLowerCase().indexOf(term) > -1;
    }
  @ViewChild("mafocus", { static: false }) mafocus: ElementRef;
  bnguonkinhphi: boolean = false;
  bnhomctmt: boolean = false;
  currentUser: any;
  loadDataInit(nhomdoituongid: string, id: string, donviid: string) {

    //if (nhomdoituongid.toLocaleLowerCase() === Lists_tinhchatnguonkp.id.toLocaleLowerCase())
    //  this.bnguonkinhphi = true;

    //if (nhomdoituongid.toLocaleLowerCase() === Lists_cmmt.id.toLocaleLowerCase())
    //  this.bnhomctmt = true;

    //if (nhomdoituongid.toLocaleUpperCase() == "5E79BF59-78D9-4C54-8EF7-0A242F5CBC24")
    //  this.hoatdong = "Ngừng theo dõi"
    //else
      this.hoatdong = "Hoạt động"

          var authlogin = localStorage.getItem('currentUser');
          if (authlogin) {

            this.currentUser = JSON.parse(authlogin);
            var giatri = this.currentUser.ds_quyen.filter(name => name.Id === nhomdoituongid.toLowerCase());
            if (giatri != null && giatri.length > 0) {
              if (giatri[0].Them == true)
                this.quyen_them = true;
              else
                this.quyen_them = false;
              if (giatri[0].Sua == true)
                this.quyen_sua = true;
              else
                this.quyen_sua = false;
              if (giatri[0].Xoa == true)
                this.quyen_xoa = true;
              else
                this.quyen_xoa = false;
            }
          }    

        this.nhomdtid = nhomdoituongid;
        setTimeout(() => {
            this.mafocus.nativeElement.focus();  
        },500);
        //this.repo.getRequest("api/doituong/getall2/" + nhomdoituongid + '/'+id+'/'+donviid)
        //.subscribe(response => {            
        //    this.inputparents=response;
        //});
   

    this.doituongSelect = {
      Id: null, SoBaoDanh: null, HoVaTen: null, NgaySinh: null, SoCMND: null, NgayCap: null, NoiCap: null
      , TenDonVi: null, Email: null, NgayHetHan: null, NgayCapS: null, NgayHetHanS: null
      , PhanHeId: null, Created: null, Modified: null, CreatedBy: null, ModifiedBy: null
    };
    this.ngaycap = null;
    this.ngayhethan = null;
    this.ngaysinh = null;
        if(id === null)
        {
          this.doituongSelect.PhanHeId = nhomdoituongid;
          this.doituongSelect.Created = new Date();
          this.doituongSelect.CreatedBy = this.currentUser.user_name;
          this.doituongSelect.Modified = new Date();
          this.doituongSelect.ModifiedBy = this.currentUser.user_name;
          
        }
        else {
          console.log("t11");
          this.repo.postRequest("api/danhsachthi/getbyid/", { IdGuid: id, PhanHeId: nhomdoituongid })
            .subscribe(response => {  
                console.log(response);
              this.doituongSelect.Id = id;
              this.doituongSelect.SoBaoDanh = response.SoBaoDanh;
              this.doituongSelect.HoVaTen = response.HoVaTen;
              this.doituongSelect.NgaySinh = response.NgaySinh;
              this.doituongSelect.PhanHeId = nhomdoituongid;
              this.doituongSelect.Created = response.Created;
              this.doituongSelect.CreatedBy = response.CreatedBy;
              this.doituongSelect.Modified = new Date();
              this.doituongSelect.ModifiedBy = this.currentUser.user_name;
              
              this.doituongSelect.SoCMND = response.SoCMND;
              this.doituongSelect.NgayCap = response.NgayCap;
              this.doituongSelect.NoiCap = response.NoiCap;
              this.doituongSelect.TenDonVi = response.TenDonVi;
              this.doituongSelect.Email = response.Email;
              this.doituongSelect.NgayHetHan = response.NgayHetHan;

              if (response.NgayCap != null)
                this.ngaycap = new Date(response.NgayCap);
              else
                this.ngaycap = null;
              if (response.NgayHetHan != null)
                this.ngayhethan = new Date(response.NgayHetHan);
              else
                this.ngayhethan = null;
              if (response.NgaySinh != null)
                this.ngaysinh = new Date(response.NgaySinh);
              else
                this.ngaysinh = null;

            }); 
        }
        
       
    }
   
    keyTenPress(event: any) { 
        if (event.which === 13) {
            this.slCapTren.focus();
            event.preventDefault();
          }
   }
    public closeModal(){
        this.save.emit(null);
    }
  public saveproduct() {
    if (this.doituongSelect.SoBaoDanh == null || this.doituongSelect.SoBaoDanh == "") {
      swal('Lỗi!', 'Vui lòng nhập mã đăng nhập!.', 'error');
      return;
    }
    if (this.doituongSelect.HoVaTen == null || this.doituongSelect.HoVaTen == "") {
            swal('Lỗi!', 'Vui lòng nhập Họ tên cán bộ!.', 'error');
            return;
    }

    if (this.ngaycap != null)
      this.doituongSelect.NgayCapS = this.ngaycap.getDate() + '/' + (this.ngaycap.getMonth() + 1) + '/' + this.ngaycap.getFullYear();
    if (this.ngayhethan != null)
      this.doituongSelect.NgayHetHanS = this.ngayhethan.getDate() + '/' + (this.ngayhethan.getMonth() + 1) + '/' + this.ngayhethan.getFullYear()
        + '/' + this.ngayhethan.getHours() + '/' + this.ngayhethan.getMinutes()
        + '/' + this.ngayhethan.getSeconds();

        this.repo.postRequest("api/danhsachthi/addorupdate",this.doituongSelect)
            .subscribe(response => {  
              console.log(response);
              if (response != null && response.match('-')) {
                this.save.emit(this.doituongSelect);
              }
              else {
                swal('Lỗi!', response, 'error');
              }
            }); 
    }
   
    
   

   


}
